/**
 * @file Utilities for working with Shareable Health Links (SHLs).
 */

import { decode } from 'base-64';
import { memoize } from 'lodash';
import moment from 'moment-timezone';

/**
 * Decode and parse the given SHL.
 * @param {string} shl The SHL to parse.
 * @returns {object} The parsed SHL.
 */
export const parseSHL = memoize((shl) => JSON.parse(decode(shl)));

/**
 * Check if the given SHL is expired.
 * @param {string} shl The SHL to check.
 * @returns {boolean} `true` if the SHL is expired, otherwise `false`.
 */
export const isSHLExpired = (shl) => {
  const expiryDate = moment.unix(parseSHL(shl).exp);
  return moment().isSameOrAfter(expiryDate, 'second');
};
